module.exports = __webpack_public_path__ + "f8a1479bbc7c8672685456f3f4ebcd50.png";